module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contentsPage",
    attrs: {
      "id": "d7e159"
    }
  }, [_c('h3', {
    staticClass: "toc",
    attrs: {
      "id": "d7e160"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_int#int"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h4', [_vm._v("Part I")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_p1#p1"
    }
  }, [_vm._v("The ABCs of Reverse Mortgages")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c1#c1"
    }
  }, [_vm._v("CHAPTER 1: The Reverse Mortgage Story")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c2#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2: Reverse Mortgage Basics")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h4', [_vm._v("Part II")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_p2#p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Considering the Options")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c3#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3: Home Equity Conversion Mortgages")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4: Fannie Mae Home Keeper Mortgage")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c5#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5: Financial Freedom Cash Account Advantage Plan")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h4', [_vm._v("Part III")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_p3#p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Planning")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6: Health Care, Long-Term Care, and Government Benefits")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7: Alternatives to a Reverse Mortgage")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c8#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8: What Is a Reverse Mortgage Worth to Me?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h4', [_vm._v("Part IV")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_p4#p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making It Happen")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c9#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9: The Reverse Mortgage Team")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10: Choosing the Right Loan and Other Decisions")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11: Demystifying the Approval Process")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h4', [_vm._v("Part V")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_p5#p5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Important Considerations")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12: Closing and Managing a Reverse Mortgage")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13: Special Circumstances and Considerations")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX A: Loan Comparison Worksheets")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX B: Loan-Specific Worksheets")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX C: Resources")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX D: Glossary")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Krae_9781440501029_epub_c19#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")]), _vm._v(" "), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638c4f33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Krae_9781440501029_epub_toc.vue
// module id = 75
// module chunks = 0